import { SAMPLE, momMeta, num } from '../data/sample';
import { openApp } from '../state';

const GRID = '2.2fr 1fr 1fr 1.2fr 0.8fr';

export function AppsList() {
  const d = SAMPLE;
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #e1e3e5',
        borderRadius: 14,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: GRID,
          gap: 12,
          padding: '12px 18px',
          borderBottom: '1px solid #e1e3e5',
          background: '#fafbfb',
          fontSize: 11,
          fontWeight: 700,
          color: '#6d7175',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}
      >
        <span>App</span>
        <span>Reviews</span>
        <span>Rating</span>
        <span>Function coverage</span>
        <span style={{ textAlign: 'right' }}>Momentum</span>
      </div>
      {d.apps.map((a) => {
        const mm = momMeta(a.mom);
        const covered = a.depths.filter((x) => x > 0).length;
        return (
          <div
            key={a.id}
            onClick={() => openApp(a.id)}
            style={{
              display: 'grid',
              gridTemplateColumns: GRID,
              gap: 12,
              alignItems: 'center',
              padding: '13px 18px',
              borderBottom: '1px solid #f1f1f1',
              cursor: 'pointer',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
              <div
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 9,
                  background: a.iconBg,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 800,
                  fontSize: 13,
                  color: '#303030',
                }}
              >
                {a.initials}
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700 }}>{a.name}</div>
                <div style={{ fontSize: 11.5, color: '#a5abb5' }}>{a.vendor}</div>
              </div>
            </div>
            <span style={{ fontFamily: "'JetBrains Mono'", fontSize: 13, fontWeight: 600 }}>
              {num(a.reviews)}
            </span>
            <span style={{ fontFamily: "'JetBrains Mono'", fontSize: 13, fontWeight: 600 }}>
              ★ {a.rating}
            </span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div
                style={{
                  flex: 1,
                  height: 6,
                  borderRadius: 4,
                  background: '#ebebeb',
                  overflow: 'hidden',
                  maxWidth: 90,
                }}
              >
                <div
                  style={{
                    height: '100%',
                    width: `${Math.round((covered / d.functions.length) * 100)}%`,
                    background: '#2c6ecb',
                    borderRadius: 4,
                  }}
                />
              </div>
              <span style={{ fontFamily: "'JetBrains Mono'", fontSize: 11.5, color: '#6d7175' }}>
                {covered}/{d.functions.length}
              </span>
            </div>
            <div style={{ textAlign: 'right', fontWeight: 700, fontSize: 12.5, color: mm.fg }}>
              <span style={{ fontFamily: "'JetBrains Mono'" }}>{mm.arrow}</span> {mm.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
